<template>
    <div class="layout-px-spacing">
        <div class="row layout-top-spacing">
            <div class="col-xl-12 col-lg-12 col-md-12 col-12 layout-spacing">
                <div class="panel br-4">
                    <div class="panel-body text-center">
                        <h1 class="text-danger">403 - Forbidden</h1>
                        <p>You don't have permission to access this page.</p>
                        <router-link to="/home" class="btn btn-primary">
                            Return to Dashboard
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { useMeta } from "/src/composables/use-meta";
useMeta({ title: "Unauthorized Access" });
</script>